module.exports = __webpack_public_path__ + "img/what-we-sell_0006.cacdf60b.jpg";